import { useState } from "react";
import { getLessonsForGroup, getLessonsFromLocalStorage, saveLessonsToLocalStorage } from '../utils/lessonsService';
import { getHomeworkById } from '../utils/homeworkService';

export function useGroupHomework({ groupId, navigate, groupHomework, setStudentLessons, updateUpcomingLessons }) {
  const [homeworkFilter, setHomeworkFilter] = useState('all'); // 'all', 'assigned', 'submitted', 'reviewed'
  const [selectedHomework, setSelectedHomework] = useState(null);
  const [editingHomeworkId, setEditingHomeworkId] = useState(null);
  const [editingHomeworkText, setEditingHomeworkText] = useState('');

  // eslint-disable-next-line no-unused-vars
  const handleAddHomework = (lessonId) => {
    setEditingHomeworkId(lessonId);
    setEditingHomeworkText('');
  };

  // eslint-disable-next-line no-unused-vars
  const handleEditHomework = (lessonId, currentHomework) => {
    setEditingHomeworkId(lessonId);
    setEditingHomeworkText(currentHomework || '');
  };

  // eslint-disable-next-line no-unused-vars
  const handleSaveHomework = (lessonId) => {
    // Обновляем урок в основном хранилище
    const allLessons = getLessonsFromLocalStorage();
    const updatedLessons = allLessons.map(lesson =>
      lesson.id === lessonId ? { ...lesson, homework: editingHomeworkText } : lesson
    );
    saveLessonsToLocalStorage(updatedLessons);

    // Обновляем локальное состояние
    setStudentLessons(prev => prev.map(lesson =>
      lesson.id === lessonId ? { ...lesson, homework: editingHomeworkText } : lesson
    ));

    console.log('Homework saved for lesson:', lessonId);

    // Принудительно обновляем список уроков после сохранения домашнего задания
    setTimeout(() => {
      getLessonsForGroup(groupId).then(lessons => {
        setStudentLessons(lessons);
        updateUpcomingLessons(); // Обновляем upcoming lessons
      }).catch(error => {
        console.error('Error loading lessons:', error);
      });
    }, 100);

    setEditingHomeworkId(null);
    setEditingHomeworkText('');
  };

  // eslint-disable-next-line no-unused-vars
  const handleCancelHomework = () => {
    setEditingHomeworkId(null);
    setEditingHomeworkText('');
  };

  const handleOpenHomework = (homeworkId) => {
    const homework = groupHomework.find(h => h.id === homeworkId);
    if (homework) {
      setSelectedHomework(homework);
    }
  };

  const handleCloseHomework = () => {
    setSelectedHomework(null);
  };

  const handleCheckHomework = async (homeworkId) => {
    setSelectedHomework(null);
    let lessonId = null;
    try {
      const fromSupabase = await getHomeworkById(homeworkId);
      if (fromSupabase?.lessonId) lessonId = fromSupabase.lessonId;
    } catch (_) {}
    if (!lessonId) {
      const homeworkData = JSON.parse(localStorage.getItem(`homework_${homeworkId}`) || '{}');
      lessonId = homeworkData.lessonId || 'new';
    }
    navigate(`/lessons/${lessonId}?homeworkId=${homeworkId}&groupId=${groupId}`);
  };

  return {
    homeworkFilter, setHomeworkFilter,
    selectedHomework, setSelectedHomework,
    editingHomeworkId, setEditingHomeworkId,
    editingHomeworkText, setEditingHomeworkText,
    handleAddHomework, handleEditHomework, handleSaveHomework, handleCancelHomework,
    handleOpenHomework, handleCloseHomework, handleCheckHomework,
  };
}
